"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueEditor = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var typeFromValue_1 = __importDefault(require("../../utils/typeFromValue"));
var valueFromType_1 = __importDefault(require("../../utils/valueFromType"));
var ArrayEditor_1 = require("./ArrayEditor");
var BooleanEditor_1 = require("./BooleanEditor");
var NumberEditor_1 = require("./NumberEditor");
var ObjectEditor_1 = require("./ObjectEditor");
var StringEditor_1 = require("./StringEditor");
var types = [
    { name: 'Number', value: 'number' },
    { name: 'String', value: 'string' },
    { name: 'Boolean', value: 'boolean' },
    { name: 'Array', value: 'array' },
    { name: 'Object', value: 'object' },
    { name: 'Null', value: 'null' },
];
var typeByValue = types.reduce(function (acc, item) {
    acc[item.value] = item;
    return acc;
}, {});
function ValueEditor(_a) {
    var value = _a.value, onChange = _a.onChange, newArrayItemValue = _a.newArrayItemValue, onEdit = _a.onEdit, newObjectItemValue = _a.newObjectItemValue, newObjectItemKey = _a.newObjectItemKey;
    var updateValue = function (type) {
        onChange((0, valueFromType_1.default)(type));
    };
    var valueType = (0, typeFromValue_1.default)(value);
    var valueEditor = (function () {
        switch (valueType) {
            case 'number':
                return react_1.default.createElement(NumberEditor_1.NumberEditor, { label: "Value", value: value, onChange: onChange });
            case 'string':
                return react_1.default.createElement(StringEditor_1.StringEditor, { label: "Value", value: value, onChange: onChange });
            case 'boolean':
                return react_1.default.createElement(BooleanEditor_1.BooleanEditor, { label: "Value", value: value, onChange: onChange });
            case 'array':
                return (react_1.default.createElement(material_1.Stack, { display: "flex", direction: "column", justifyContent: "flex-start", alignItems: "flex-start", width: "100%", flex: "1", spacing: 1 },
                    react_1.default.createElement(material_1.InputLabel, null,
                        "Items (",
                        value.length,
                        ")"),
                    react_1.default.createElement(ArrayEditor_1.ArrayEditor, { newItemValue: newArrayItemValue, onEdit: onEdit, value: value, onChange: onChange })));
            case 'object':
                return (react_1.default.createElement(material_1.Stack, { display: "flex", direction: "column", justifyContent: "flex-start", alignItems: "flex-start", width: "100%", flex: "1", spacing: 1 },
                    react_1.default.createElement(material_1.InputLabel, null,
                        "Properties (",
                        Object.keys(value).length,
                        ")"),
                    react_1.default.createElement(ObjectEditor_1.ObjectEditor, { newItemValue: newObjectItemValue, newItemKey: newObjectItemKey, value: value, onEdit: onEdit, onChange: onChange })));
            default:
                return '';
        }
    })();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.TextField, { select: true, label: "Type", size: "small", fullWidth: true, value: typeByValue[valueType].value, onChange: function (e) { return updateValue(e.target.value); } }, types.map(function (typeObj) { return (react_1.default.createElement(material_1.MenuItem, { key: typeObj.value, value: typeObj.value }, typeObj.name)); })),
        valueEditor));
}
exports.ValueEditor = ValueEditor;
